import script from "./compGroupWorkflowCoverage.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupWorkflowCoverage.vue?vue&type=script&setup=true&lang=js"

import "./compGroupWorkflowCoverage.vue?vue&type=style&index=0&id=db8bb34c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db8bb34c"]])

export default __exports__